import { HeadingTag, Link, ModuleBase, ResponsiveImage } from '@/components';
import { ImageModel, LinkModel, ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import classNames from 'classnames';

type FeaturedModuleModel = ModuleBaseModel<
  {
    text: string;
    image: {
      desktopImage: ImageModel;
      mobileImage: ImageModel;
    };
    theme: string;
    link?: LinkModel;
  } & ModuleSectionPropsModel
>;

const FeaturedModule = (data: FeaturedModuleModel) => {
  const {
    props: { text, image, theme, headingTag, heading, link },
  } = data;

  return (
    <ModuleBase
      data={data}
      noPadding
      className={classNames(theme === 'Dark' ? 'module-base-dark' : 'module-base-light')}
    >
      <div className="relative">
        {image && (
          <div className="relative top-0 left-0 w-full">
            <div className="relative top-0 left-0 h-full w-full">
              <ResponsiveImage
                image={image.desktopImage}
                widths={{ xs: 1, sm: 768, md: 1024, lg: 1440, xl: 1904, xxl: 2560 }}
                heights={{ xs: 1, sm: 300, lg: null }}
                dataNotLazy
                preload
                className="hidden overflow-hidden sm:block"
                imgProps={{ className: 'max-h-[300px]' }}
              />
              <ResponsiveImage
                image={image.mobileImage}
                widths={{ xs: 600, sm: 1 }}
                heights={{ xs: 300, sm: 1 }}
                dataNotLazy
                preload
                className="sm:hidden"
              />
            </div>
          </div>
        )}
        <div className="absolute top-0 left-0 h-full w-full">
          <div className="container mx-auto flex h-full flex-col justify-center">
            <div className="w-8/12 pl-3 sm:w-1/2 lg:w-5/12 xl:pr-1">
              {heading && (
                <HeadingTag
                  tag={headingTag}
                  heading={heading}
                  role="contentinfo"
                  aria-label="contentinfo"
                  className="color-from-bg mb-3 justify-center font-light"
                />
              )}

              {text && (
                <div className="color-from-bg text-heading6 tracking-heading6 mb-4 leading-8 font-light not-italic">
                  <div className="text-sm font-medium xl:text-base" dangerouslySetInnerHTML={{ __html: text }} />
                </div>
              )}
              {link && <Link animate link={link} className="btn btn-from-bg underline" />}
            </div>
          </div>
        </div>
      </div>
    </ModuleBase>
  );
};

export default FeaturedModule;
